import { useContext } from 'react'

import {
  Columns, ModalContext, LoadingModule, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import EntityModule from '@components/EntityModule'
import NotificationBannerLocation from '@components/NotificationBannerLocation'

import OrderItem from './components/OrderItem/OrderItem'

import useMediaReviewer from './hooks/useMediaReviewer'

const MODAL_KEY = 'MediaReviewerModal'

export type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const MediaReviewerModal = (props: ModalProps) => {
  const { callbacks, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { campaign: initCampaign, provider: initProvider } = modalPayload

  const mediaReviewerPayload = useMediaReviewer({ campaign: initCampaign, provider: initProvider })

  const {
    campaign: {
      address,
      default_image,
    },
    filteredOrderItems,
    loadingCampaign,
    loadingOrders,
    loadingProvider,
    provider: {
      title,
    },
    providerLogoUrl,
  } = mediaReviewerPayload

  return (
    <SidebarModal
      callbacks={callbacks}
      disableAnimation
      modalKey={MODAL_KEY}
      showModal={showModal}
      size="fullscreen"
    >
      <SidebarModal.Header callbacks={callbacks} title="Media" titleSecondLine="Proofing" />

      <SidebarModal.Content boxProps={{ backgroundColor: 'backgroundColor' }} hasFooter={false}>
        <Columns flexDirection={['column', 'column', 'row']} boxProps={{ marginX: 'auto', maxWidth: 1400 }}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.mediaReviewer.campaign.banner" />

            <LoadingModule loading={loadingOrders} times={3} />

            {!loadingOrders && (
              filteredOrderItems.map(orderItem => <OrderItem key={orderItem.id} orderItem={orderItem} />)
            )}
          </Columns.Main>

          <Columns.Sidebar>
            {/*
             // @ts-expect-error TS2322 */}
            <EntityModule entityName="Campaign" image={default_image} loading={loadingCampaign} title={address} />

            <EntityModule entityName="Provider" image={providerLogoUrl} loading={loadingProvider} title={title} />
          </Columns.Sidebar>
        </Columns>
      </SidebarModal.Content>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <MediaReviewerModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
